<div class="sm:hidden mx:block official-website-content">
  <div class="header-title" style="margin-bottom: 40px;">
    <h1><span>配件目录</span></h1>
  </div>
  <div class="parts-content">
    <nz-tabset [(nzSelectedIndex)]="selectedTabIndex" (nzSelectedIndexChange)="onTabChange($event)"
      [hidden]="showDetail">
      <nz-tab nzTitle="车型搜索">
        <div *ngIf="carModalVisible">
          <app-vin-search (dataEvent)="receiveData($event)" *ngIf="isVinSearchVisible"></app-vin-search>
          <app-vin-parts-search [activeTabIndex]="selectedTabIndex" (dataEvent)="receivePartsData($event)"
            *ngIf="isVinPartsSearchVisible" (viewDetail)="onViewDetail($event)"></app-vin-parts-search>
        </div>
      </nz-tab>
      <nz-tab nzTitle="产品搜索">
        <div *ngIf="productVisible">
          <app-product-search (searchByPartNo)="onSearchByPartNo($event)"></app-product-search>
          <app-vin-parts-search [activeTabIndex]="selectedTabIndex" *ngIf="isProductVinPartsSearchVisible"
            (viewDetail)="onViewDetail($event)" (clearPartNoToFilter)="clearPartNoToFilter()"></app-vin-parts-search>
        </div>
      </nz-tab>
    </nz-tabset>
    <app-part-detail [activeTabIndex]="selectedTabIndex" *ngIf="showDetail" [id]="selectedItem"
      (goBackView)="onBack()"></app-part-detail>
  </div>
</div>

<div class="sm:block mx:hidden">
  <ecat-mobile-homepage *ngIf="!showDetail"></ecat-mobile-homepage>
  <!-- <app-part-detail [activeTabIndex]="selectedTabIndex" *ngIf="showDetail" [id]="selectedItem"
    (goBackView)="onBack()"></app-part-detail> -->
</div>